export type InventoryOriginKind = "csv_import" | "manual" | "live";

/** inventory_events.pool_type — derived from registry origin_kind (live → platform). */
export type LedgerPoolType = "received" | "platform";

export function poolTypeFromOriginKind(originKind: InventoryOriginKind): LedgerPoolType {
  return originKind === "live" ? "platform" : "received";
}

export interface InventoryRegistrySourceRow {
  source: string;
  display_label: string;
  origin_kind: InventoryOriginKind;
  sales_deductions_allowed: boolean;
  connection_id: string | null;
  last_sync_at: string | null;
}
